import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  id: "tags-view-container",
  class: "tags-view-container flex align-center"
};
const _hoisted_2 = ["onClick", "onMouseup", "onContextmenu"];
const _hoisted_3 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Close = _resolveComponent("Close");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_router_link = _resolveComponent("router-link");
  const _component_ScrollPane = _resolveComponent("ScrollPane");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_ScrollPane, {
    ref: "scrollPaneRef",
    class: "tags-view-wrapper flex align-center mt-8",
    onScroll: _ctx.handleScroll
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visitedViews, tag => {
      return _openBlock(), _createBlock(_component_router_link, {
        ref_for: true,
        ref: "tag",
        key: tag.path,
        to: {
          path: tag.path,
          query: tag.query,
          fullPath: tag.fullPath
        },
        custom: "",
        class: "mr-10 flex align-center"
      }, {
        default: _withCtx(({
          navigate,
          isActive
        }) => [_createElementVNode("span", {
          class: _normalizeClass([[isActive ? 'active' : '', 'tags-view-item'], "flex align-center"]),
          onClick: navigate,
          onMouseup: _withModifiers($event => !_ctx.isAffix(tag) ? _ctx.closeSelectedTag(tag) : '', ["middle"]),
          onContextmenu: _withModifiers($event => _ctx.openMenu(tag, $event), ["prevent"])
        }, [_createTextVNode(_toDisplayString(tag?.meta?.title) + " ", 1), !_ctx.isAffix(tag) ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "el-icon-close",
          onClick: _withModifiers($event => _ctx.closeSelectedTag(tag), ["prevent", "stop"])
        }, [_createVNode(_component_el_icon, {
          size: 16,
          class: "input-icon"
        }, {
          default: _withCtx(() => [_createVNode(_component_Close, {
            class: "icon"
          })]),
          _: 1
        })], 8, _hoisted_3)) : _createCommentVNode("", true)], 42, _hoisted_2)]),
        _: 2
      }, 1032, ["to"]);
    }), 128))]),
    _: 1
  }, 8, ["onScroll"]), _ctx.isShowMenu ? (_openBlock(), _createElementBlock("ul", {
    key: 0,
    style: _normalizeStyle({
      left: _ctx.left + 'px',
      top: _ctx.top + 'px'
    }),
    class: "contextmenu"
  }, [_createElementVNode("li", {
    onClick: _cache[0] || (_cache[0] = $event => _ctx.refreshSelectedTag(_ctx.selectedTag))
  }, _toDisplayString(_ctx.t('刷新')), 1), !_ctx.isAffix(_ctx.selectedTag) ? (_openBlock(), _createElementBlock("li", {
    key: 0,
    onClick: _cache[1] || (_cache[1] = $event => _ctx.closeSelectedTag(_ctx.selectedTag))
  }, _toDisplayString(_ctx.t('关闭当前页')), 1)) : _createCommentVNode("", true), _createElementVNode("li", {
    onClick: _cache[2] || (_cache[2] =
    //@ts-ignore
    (...args) => _ctx.closeOthersTags && _ctx.closeOthersTags(...args))
  }, _toDisplayString(_ctx.t('关闭其他')), 1), _createElementVNode("li", {
    onClick: _cache[3] || (_cache[3] = $event => _ctx.closeAllTags(_ctx.selectedTag))
  }, _toDisplayString(_ctx.t('关闭全部')), 1)], 4)) : _createCommentVNode("", true)]);
}